import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseHttpService } from "../base-http.service";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class FormSubmissionsService extends BaseHttpService {
    constructor(private http: HttpClient) {
        super();
    }

    /**
     * Submit a form with the provided data
     */
    submitForm(componentId: number, formData: any): Observable<any> {
        const params = {
            component_id: componentId,
            form_data: formData
        };

        return this.http.post(`${this.baseUrl}/form-submissions`, params);
    }

    /**
     * Check if the user has already submitted this form
     */
    checkSubmission(componentId: number): Observable<any> {
        return this.http.get(
            `${this.baseUrl}/form-submissions/check/${componentId}`
        );
    }
}
